'use strict';
app = angular.module('harriApp');
/**
 * Directive used to check the minimum number of model array length
 *
 * Example:
 * <input ng-model="myArrray" array-min-len="3" .. />
 */
app.directive('arrayMinLen', ['$timeout', function ($timeout) {
    return {
        require: 'ngModel',
        scope: {
            'arrayMinLen': '='
        },
        link: function (scope, elem, attrs, ctrl) {
            scope.arrayMinLen = parseInt(scope.arrayMinLen);
            $timeout(function () {
                ctrl.$parsers.unshift(checkMinLength);
                ctrl.$formatters.unshift(checkMinLength);

                function checkMinLength(viewValue) {
                    if (viewValue && viewValue.length && viewValue.length < scope.arrayMinLen) {
                        ctrl.$setValidity('minlen', false);
                    }
                    else {
                        ctrl.$setValidity('minlen', true);
                    }
                    return  viewValue;
                }
            });

        }
    }

}]);
